import { gql } from '@apollo/client/core';

export const WIDGET_CONFIG_FIELDS = gql`
  fragment WidgetConfigFields on WidgetConfig {
    id
    description
    loaderUrl
    embedUrl
    configuration
    style
  }
`;
